import React from 'react'

const LoadingComp: React.FC = () => {
  return (
    <>
      <div
        style={{
          width: '100vw',
          height: '100vh',
          position: 'absolute',
          zIndex: 999,
          background: '#eeeeee70',
          overflow: 'hidden',
        }}
      >
        <div className='loader'></div>
      </div>
    </>
  )
}
export default LoadingComp
